export default __webpack_public_path__ + "static/media/icon-check.bac9b433.svg";